var $bc031f55e87bf7fc$export$3d7865934588d77e;
(function(EventType) {
    EventType[EventType["Exploration"] = 0] = "Exploration";
    EventType[EventType["Combat"] = 1] = "Combat";
    EventType[EventType["Place"] = 2] = "Place";
    EventType[EventType["Psychological"] = 3] = "Psychological";
})($bc031f55e87bf7fc$export$3d7865934588d77e || ($bc031f55e87bf7fc$export$3d7865934588d77e = {}));
class $bc031f55e87bf7fc$export$d61e24a684f9e51 {
    constructor(title, description, image, firstChoice, secondChoice, type, character, items){
        this._items = [];
        this._title = title;
        this._description = description;
        this._image = image;
        this.firstChoice = firstChoice;
        this.secondChoice = secondChoice;
        this._type = type;
        this._items = items ?? [];
        this._character = character;
    }
    get title() {
        return this._title;
    }
    get subtitle() {
        return this._subtitle;
    }
    get description() {
        return this._description;
    }
    get image() {
        return this._image;
    }
    get type() {
        return this._type;
    }
    get items() {
        return this._items;
    }
    willGiveItems() {
        return this._items ? this._items.length > 0 : false;
    }
}








var $25f141f40fab0fb1$export$df7cd2a2d7088cfa;
(function(GameStates) {
    GameStates[GameStates["EVENT"] = 0] = "EVENT";
    GameStates[GameStates["SKILLCHECK"] = 1] = "SKILLCHECK";
    GameStates[GameStates["GAME_OVER"] = 2] = "GAME_OVER";
    GameStates[GameStates["RIP"] = 3] = "RIP";
    GameStates[GameStates["LOG"] = 4] = "LOG";
    GameStates[GameStates["BAG"] = 5] = "BAG";
    GameStates[GameStates["ITEM_PICKER"] = 6] = "ITEM_PICKER";
    GameStates[GameStates["DIALOG"] = 7] = "DIALOG";
    GameStates[GameStates["MAP"] = 8] = "MAP";
    GameStates[GameStates["SKILL_UP"] = 9] = "SKILL_UP";
})($25f141f40fab0fb1$export$df7cd2a2d7088cfa || ($25f141f40fab0fb1$export$df7cd2a2d7088cfa = {}));


var $9c7a2a4f88c432f6$export$a0472aa3a356446c;
(function(LogType) {
    LogType[LogType["Result"] = 0] = "Result";
    LogType[LogType["StatusChange"] = 1] = "StatusChange";
})($9c7a2a4f88c432f6$export$a0472aa3a356446c || ($9c7a2a4f88c432f6$export$a0472aa3a356446c = {}));
class $9c7a2a4f88c432f6$export$49b118289be48034 {
    constructor(){
        this._tempResultLogs = [];
        this._tempoStatusChangeLogs = [];
        this._logs = [];
        this._hoursSleeping = 0;
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this.initializeElements();
        this.addEventListeners();
        this.showTravelledDistance();
        this.getAtributesPageElements();
    }
    initializeElements() {
        this._logListResult = document.querySelector("#log-list-result");
        this._bagBtn = document.querySelector("#bag-btn");
        this._walkBtn = document.querySelector("#walk-btn");
        this._yourFamily = document.querySelector("#your-family");
        this._travelledDistanceField = document.querySelector("#travelled-distance");
        this._progressBarCanvasElement = document.getElementById("progress-bar");
        this._charactersList = [];
    }
    addEventListeners() {
        this._bagBtn.addEventListener("click", ()=>this.onClickBag());
        this._walkBtn.addEventListener("click", ()=>this.onClickWalkBtn());
    }
    start() {
        this.showLogs();
        this.updateBagButton();
        this.updateWalkButton();
        this.showCharacters();
        this.showProgressBarCanvas();
    }
    updateBagButton() {
        if (this._game.bagManager.isEmpty()) {
            this._bagBtn.innerHTML = this._game.loc.l("bag-is-empty");
            this._bagBtn.disabled = true;
        } else {
            this._bagBtn.innerHTML = `Open bag (${this._game.bagManager.showQuantityOfItems()})`;
            this._bagBtn.disabled = false;
        }
    }
    updateWalkButton() {
        this._walkBtn.innerHTML = this._game.loc.l("walk-one-hour");
    }
    showLogs() {
        this._logs = this._tempoStatusChangeLogs;
        this._tempoStatusChangeLogs = [];
        this._logListResult.innerHTML = "";
        this.showResultLogs();
    }
    showResultLogs() {
        let result_logs = "";
        let count = 0;
        const stop = setInterval(()=>{
            if (count < this._tempResultLogs.length) {
                this._game.audioManager.playWriteSound();
                result_logs += `<li>${this._tempResultLogs[count]}</li>`;
                this._logListResult.innerHTML = result_logs;
                count++;
            } else {
                clearInterval(stop);
                this._logs = this._tempResultLogs;
                this._tempResultLogs = [];
                this._game.characterManager.savePreviousCharacters();
            }
        }, 300);
    }
    createLogsForStatusChange() {
        const previousCharacters = this._game.characterManager.previousCharacters;
        const currentCharacters = this._game.characterManager.characters;
        let status_change_logs = "";
        for(let i = 0; i < previousCharacters.length; i++){
            const prev = previousCharacters[i];
            const curr = currentCharacters[i];
            if (!curr.isDead && prev.sanity !== curr.sanity) {
                status_change_logs += `<li> ${curr.name} Sanity: `;
                const sanityDifference = curr.sanity - prev.sanity;
                status_change_logs += sanityDifference > 0 ? `+${sanityDifference}%` : `-${-sanityDifference}%`;
                status_change_logs += "</li>";
            }
        }
        return status_change_logs;
    }
    clearLogs() {
        this._logListResult.innerHTML = "";
    }
    isThereAnyTemporaryLog() {
        return this._tempResultLogs.length > 0 || this._tempoStatusChangeLogs.length > 0;
    }
    addTempLog(log, logType) {
        if (logType === 0) this._tempResultLogs.push(log);
        else this._tempoStatusChangeLogs.push(log);
    }
    onClickBag() {
        this._game.audioManager.playButtonSound();
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).BAG);
    }
    onClickCampBtn() {
        this.disableButtons();
        this._yourFamily.innerHTML = "Camping...";
        this._sleepIntervalId = window.setInterval(()=>this.sleeping(), 500);
    }
    disableButtons() {
        this._bagBtn.disabled = true;
        this._walkBtn.disabled = true;
    }
    enableButtons() {
        this._bagBtn.disabled = false;
        this._walkBtn.disabled = false;
    }
    sleeping() {
        if (this._hoursSleeping <= 6) {
            this.updateCharacterSleepingStatus();
            this._game.passOneHour();
            this._hoursSleeping++;
        } else this.onWakeUp();
    }
    updateCharacterSleepingStatus() {
        this._game.characters.forEach((character, index)=>{
            if (!character.isDead) {
                const randomNumber = this.getRandomCharacterStatus();
                this._charactersList[index].atributesField.innerHTML = randomNumber;
            }
        });
    }
    onWakeUp() {
        this.showCharacters();
        this.enableButtons();
        this._yourFamily.innerHTML = this._game.loc.l("your-family");
        clearInterval(this._sleepIntervalId);
    }
    getRandomCharacterStatus() {
        const statusOptions = [
            "Zzz",
            "zZz",
            "zzZ"
        ];
        return statusOptions[this._game.getRandomArbitrary(0, statusOptions.length)];
    }
    onClickWalkBtn() {
        if (this._game.distanceToTheBorder === 300) this._game.audioManager.playRainSound();
        this._game.audioManager.playButtonSound();
        this._game.passOneHour();
        this.walkOneHour();
        const deadCharacters = this._game.characterManager.getCharactersDead();
        for (const character of deadCharacters)if (!character.buried) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).RIP);
            return;
        }
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).EVENT);
    }
    walkOneHour() {
        this._game.characterManager.getCharactersAlive().forEach((character)=>{
            character.walkOneHour();
        });
        this._game.decreaseTheDistanceToTheBorder(2);
        this.showTravelledDistance();
        if (this._game.distanceToTheBorder <= 0) this.arrivedAtTheBorder();
    }
    showTravelledDistance() {
        this._travelledDistanceField.innerHTML = `${this._game.distanceToTheBorder} ${this._game.loc.l("miles-to-the-border")}`;
    }
    arrivedAtTheBorder() {
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER);
    }
    getAtributesPageElements() {
        const characterIds = [
            "first",
            "second",
            "third",
            "fourth"
        ];
        characterIds.forEach((id, index)=>{
            this._charactersList[index] = {
                nameField: document.querySelector(`#${id}-character-name-field`),
                atributesField: document.querySelector(`#${id}-character-atributes-field`),
                afflictionsField: document.querySelector(`#${id}-character-afflictions-field`)
            };
        });
    }
    showCharacters() {
        const characters = [
            this._game.characterManager.characterDmytro,
            this._game.characterManager.characterOlena,
            this._game.characterManager.characterMykola,
            this._game.characterManager.characterSofiia
        ];
        characters.forEach((character, index)=>{
            this.showCharacter(character, index);
        });
    }
    showCharacter(character, index) {
        const { nameField: nameField, atributesField: atributesField, afflictionsField: afflictionsField } = this._charactersList[index];
        if (character.isDead) {
            nameField.innerHTML = `${character.name} - ${character.kinship} \u{1F480}`;
            atributesField.innerHTML = `${character.getDateOfBirth()} - 2020`;
            afflictionsField.innerHTML = "";
        } else {
            nameField.innerHTML = `${character.name} - ${character.kinship}`;
            nameField.innerHTML += character.getSickness() === "Sick" ? " [ Sick ]" : "";
            atributesField.innerHTML = character.getSanity();
            afflictionsField.innerHTML = character.showAfflictions();
        }
    }
    showProgressBarCanvas() {
        this._progressBarCanvasElement.width = 300;
        this._progressBarCanvasElement.height = 8;
        this._progressBarCanvasContext = this._progressBarCanvasElement.getContext("2d");
        this.drawProgressBarBackground();
        this.drawPlayerPositionOnProgressBarCanvas(300 - this._game.distanceToTheBorder);
    }
    drawProgressBarBackground() {
        const ctx = this._progressBarCanvasContext;
        ctx.clearRect(0, 0, this._progressBarCanvasElement.width, this._progressBarCanvasElement.height);
        ctx.fillStyle = "black";
        ctx.fillRect(0, 0, this._progressBarCanvasElement.width, this._progressBarCanvasElement.height);
        ctx.strokeStyle = "#2c3e50";
        ctx.lineWidth = 1;
        const positions = [
            10,
            75,
            150,
            225,
            290
        ];
        positions.forEach((pos)=>{
            ctx.beginPath();
            ctx.moveTo(pos, 0);
            ctx.lineTo(pos, 8);
            ctx.stroke();
            ctx.closePath();
        });
    }
    drawPlayerPositionOnProgressBarCanvas(mile) {
        const lineSize = this._progressBarCanvasElement.width - 20;
        const unit = lineSize / 300;
        const unitsToWalk = mile * unit;
        this._progressBarCanvasContext.beginPath();
        this._progressBarCanvasContext.arc(unitsToWalk + 10, 4, 3.5, 0, 2 * Math.PI);
        this._progressBarCanvasContext.fillStyle = "#27ae60";
        this._progressBarCanvasContext.fill();
    }
}


var $dc2bb2a9cc4e234e$export$6fb808e876d73c01;
(function(Difficulties) {
    Difficulties[Difficulties["TRIVIAL"] = 0] = "TRIVIAL";
    Difficulties[Difficulties["EASY"] = 1] = "EASY";
    Difficulties[Difficulties["MEDIUM"] = 2] = "MEDIUM";
    Difficulties[Difficulties["CHALLENGING"] = 3] = "CHALLENGING";
    Difficulties[Difficulties["VERY_HARD"] = 4] = "VERY_HARD";
    Difficulties[Difficulties["IMPOSSIBILE"] = 5] = "IMPOSSIBILE";
})($dc2bb2a9cc4e234e$export$6fb808e876d73c01 || ($dc2bb2a9cc4e234e$export$6fb808e876d73c01 = {}));


class $cf06d41d2f58e0f1$export$6570b7397a911979 {
    static createDmytroEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        let events = [];
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Rostos nos Escombros", "Dmytro depara-se com os corpos de uma fam\xedlia, soterrados nos escombros de uma casa destru\xedda. A vis\xe3o traz um eco de dor e desola\xe7\xe3o, como se as paredes dilaceradas daquele lar sussurrassem segredos de vidas interrompidas. A imagem crava-se em sua mente, e o medo do mesmo destino para sua pr\xf3pria fam\xedlia transforma-se em um peso opressor, como se o c\xe9u desabasse sobre seus ombros.", "", {
            buttonText: "Enfrentar",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterDmytro.increaseSanity(5);
                        this._game.log.addTempLog("Dmytro encontra for\xe7a em sua alma exausta, encarando o terror com uma chama tr\xeamula de coragem, e por um instante, a escurid\xe3o recua, devolvendo-lhe um fragmento de paz.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterDmytro.looseSanity(10);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Dmytro", "Ansiedade");
                        this._game.log.addTempLog("A vis\xe3o \xe9 um golpe demasiado cruel para sua mente j\xe1 ferida, e a imagem dos corpos assombra cada recanto de seus pensamentos, lan\xe7ando-o em um abismo de ansiedade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Evitar",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterDmytro.looseSanity(5);
                this._game.log.addTempLog("Dmytro desvia o olhar, mas a sombra daqueles rostos segue-o, como uma cicatriz na mem\xf3ria, corroendo sua sanidade com a persist\xeancia de um veneno invis\xedvel.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                this._game.log.addTempLog("Dmytro se ajoelha no solo frio, e l\xe1grimas amargas escorrem de seus olhos enquanto ele \xe9 consumido por um lamento silencioso.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterDmytro));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("O Velho Espelho", "Dmytro encontra um espelho rachado, um fragmento do passado que reflete n\xe3o apenas seu rosto cansado, mas os fantasmas daqueles que ele n\xe3o conseguiu salvar. As fissuras no vidro parecem tra\xe7ar as linhas de sua pr\xf3pria culpa, um labirinto sem sa\xedda que o aprisiona em suas falhas.", "", {
            buttonText: "Press\xe3o",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterDmytro.looseSanity(5);
                this._game.log.addTempLog("Ao encarar o espelho, Dmytro sente-se afundar sob o peso de cada reflexo, cada rosto perdido que retorna para assombr\xe1-lo, roubando-lhe mais um pouco de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, {
            buttonText: "Cautela",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterDmytro.increaseSanity(5);
                        this._game.log.addTempLog("Dmytro desvia o olhar a tempo, fechando a porta para os espectros que o espelho convocava, recuperando uma pequena parte de si mesmo no processo.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterDmytro.looseSanity(10);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Dmytro", "Culpa");
                        this._game.log.addTempLog("O reflexo fragmentado invade sua mente, e Dmytro \xe9 incapaz de evitar a torrente de culpa que o consome, como um rio subterr\xe2neo que devora a terra por dentro.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterDmytro));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Gritos Fantasmas", "Dmytro ouve gritos ao longe, ecos de um massacre h\xe1 muito ocorrido, mas que ainda ressoam como espectros em sua mente. Cada som \xe9 uma l\xe2mina cortante, um chamado que rasga a calma da noite e o arrasta de volta \xe0s mem\xf3rias que ele tenta enterrar.", "", {
            buttonText: "Confrontar",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterDmytro.increaseSanity(10);
                        this._game.log.addTempLog("Dmytro enfrenta os gritos com uma for\xe7a que ele n\xe3o sabia possuir, transpondo as barreiras do medo e emergindo um pouco mais forte, como um sobrevivente que encontra luz em meio \xe0 devasta\xe7\xe3o.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterDmytro.looseSanity(15);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Dmytro", "Trauma");
                        this._game.log.addTempLog("Os gritos s\xe3o como garras invis\xedveis, cravando-se em sua mente, arrastando Dmytro para um v\xf3rtice de lembran\xe7as e pesadelos, at\xe9 que tudo que resta \xe9 um trauma irrepar\xe1vel.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Fugir",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterDmytro.looseSanity(7);
                this._game.log.addTempLog("Dmytro tenta fugir dos gritos, mas eles se entrela\xe7am ao vento, assombrando seus passos e corroendo sua mente com uma persist\xeancia maligna.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterDmytro));
        return events;
    }
}






class $cc0da5454376274a$export$2be9c7801c485772 {
    static createMykolaEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        let events = [];
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Eco de Choro", "Mykola ouve ecos de um choro distante, que ressoam como um reflexo de sua pr\xf3pria dor.", "", {
            buttonText: "Confrontar",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterMykola.increaseSanity(5);
                        this._game.log.addTempLog("Mykola re\xfane coragem para confrontar os ecos, encontrando um breve al\xedvio em sua mente.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterMykola.looseSanity(15);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Mykola", "P\xe2nico");
                        this._game.log.addTempLog("Os ecos s\xe3o demais para Mykola, mergulhando-o em um estado de p\xe2nico incontrol\xe1vel.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Fugir",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterMykola.looseSanity(5);
                this._game.log.addTempLog("Mykola tenta escapar dos sons, mas eles continuam a persegui-lo, minando sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterMykola));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Companheiro Imagin\xe1rio", "Mykola come\xe7a a falar com algu\xe9m que ningu\xe9m mais v\xea, buscando conforto em uma presen\xe7a imagin\xe1ria.", "", {
            buttonText: "Enfrentar",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterMykola.increaseSanity(5);
                        this._game.log.addTempLog("Mykola reconhece a ilus\xe3o e consegue encontrar um pouco de equil\xedbrio, recuperando parte de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterMykola.looseSanity(10);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Mykola", "Alucina\xe7\xf5es");
                        this._game.log.addTempLog("Mykola perde o controle sobre a realidade, mergulhando em alucina\xe7\xf5es cada vez mais intensas.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Evitar",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterMykola.looseSanity(5);
                this._game.log.addTempLog("Mykola tenta ignorar a presen\xe7a imagin\xe1ria, mas a sensa\xe7\xe3o de solid\xe3o o consome, corroendo sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterMykola));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Caminho Sem Volta", "Mykola encontra um caminho sombrio e desconhecido, que parece n\xe3o ter fim.", "", {
            buttonText: "Press\xe3o",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterMykola.looseSanity(5);
                this._game.log.addTempLog("Mykola sente a press\xe3o do caminho intermin\xe1vel, perdendo um pouco de sua sanidade ao avan\xe7ar por ele.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, {
            buttonText: "Cautela",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterMykola.increaseSanity(5);
                        this._game.log.addTempLog("Mykola avan\xe7a com cautela, conseguindo manter sua mente focada e recuperar um pouco de sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterMykola.looseSanity(10);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Mykola", "Ansiedade");
                        this._game.log.addTempLog("O medo do desconhecido toma conta de Mykola, provocando uma crise de ansiedade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterMykola));
        return events;
    }
}






class $c4173844005aa122$export$b1388e5e6738eebe {
    static createOlenaEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        let events = [];
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Olhos no Escuro", "Olena sente que algo a observa na escurid\xe3o, como se olhos invis\xedveis a seguissem por onde passa.", "", {
            buttonText: "Enfrentar",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterOlena.increaseSanity(5);
                        this._game.log.addTempLog("Olena encara os olhos imagin\xe1rios na escurid\xe3o, recuperando um pouco de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterOlena.looseSanity(10);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Olena", "Paranoia");
                        this._game.log.addTempLog("A presen\xe7a invis\xedvel se torna insuport\xe1vel para Olena, levando-a a um estado de paranoia constante.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Evitar",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterOlena.looseSanity(5);
                this._game.log.addTempLog("Olena tenta ignorar os olhos na escurid\xe3o, mas a sensa\xe7\xe3o de ser observada persiste, minando sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterOlena));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Sussurros dos Mortos", "Olena ouve sussurros que parecem vir do al\xe9m, trazendo mensagens que ela n\xe3o consegue decifrar.", "", {
            buttonText: "Esperan\xe7a",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterOlena.increaseSanity(10);
                        this._game.log.addTempLog("Olena se apega a uma esperan\xe7a t\xeanue ao interpretar os sussurros como um sinal positivo, recuperando parte de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterOlena.looseSanity(15);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Olena", "Desespero");
                        this._game.log.addTempLog("Os sussurros se tornam um peso insuport\xe1vel para Olena, mergulhando-a em um profundo desespero.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Desespero",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterOlena.looseSanity(7);
                this._game.log.addTempLog("Olena cede ao desespero que os sussurros trazem, perdendo ainda mais de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterOlena));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Sil\xeancio Mortal", "Olena se depara com um sil\xeancio absoluto, um vazio que parece engolir todos os sons ao seu redor.", "", {
            buttonText: "Press\xe3o",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterOlena.looseSanity(5);
                this._game.log.addTempLog("O sil\xeancio opressor faz com que Olena se sinta cada vez mais isolada, diminuindo sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, {
            buttonText: "Cautela",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterOlena.increaseSanity(5);
                        this._game.log.addTempLog("Olena mant\xe9m a calma diante do sil\xeancio, conseguindo encontrar um ponto de equil\xedbrio em meio ao vazio.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterOlena.looseSanity(10);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Olena", "Depress\xe3o");
                        this._game.log.addTempLog("O vazio do sil\xeancio consome Olena, levando-a a um estado de depress\xe3o profunda.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterOlena));
        return events;
    }
}






class $93631e155b1431be$export$442f8eaeaf400087 {
    static createSofiiaEvents() {
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        let events = [];
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Rostos Esquecidos", "Sofiia \xe9 assombrada por rostos que n\xe3o consegue mais lembrar, como se as mem\xf3rias estivessem desaparecendo de sua mente.", "", {
            buttonText: "Esperan\xe7a",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterSofiia.increaseSanity(10);
                        this._game.log.addTempLog("Sofiia se agarra \xe0 esperan\xe7a de que as mem\xf3rias perdidas retornem, recuperando parte de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterSofiia.looseSanity(15);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Sofiia", "Isolamento");
                        this._game.log.addTempLog("A sensa\xe7\xe3o de perda \xe9 esmagadora para Sofiia, que se afasta cada vez mais dos outros, sentindo-se isolada.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Desespero",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterSofiia.looseSanity(5);
                this._game.log.addTempLog("Sofiia cede ao desespero ao perceber que as mem\xf3rias est\xe3o se esvaindo, perdendo parte de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterSofiia));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Sombras no Horizonte", "Sofiia v\xea sombras misteriosas ao longe, que parecem se aproximar lentamente, trazendo uma sensa\xe7\xe3o de medo.", "", {
            buttonText: "Confrontar",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterSofiia.increaseSanity(5);
                        this._game.log.addTempLog("Sofiia enfrenta as sombras com coragem, recuperando parte de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterSofiia.looseSanity(10);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Sofiia", "Medo");
                        this._game.log.addTempLog("O confronto com as sombras \xe9 demais para Sofiia, que sucumbe ao medo crescente.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Fugir",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterSofiia.looseSanity(5);
                this._game.log.addTempLog("Sofiia tenta escapar das sombras, mas o medo a persegue, corroendo sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterSofiia));
        events.push(new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Esperan\xe7a Quebrada", "Sofiia v\xea sua esperan\xe7a desmoronar diante dos desafios que parecem insuper\xe1veis.", "", {
            buttonText: "Esperan\xe7a",
            skillCheck: true,
            skillCheckFields: {
                difficulty: (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM,
                canGiveItems: false,
                resultPath: {
                    success: ()=>{
                        this._game.characterManager.characterSofiia.increaseSanity(10);
                        this._game.log.addTempLog("Sofiia se agarra a um fio de esperan\xe7a, encontrando for\xe7a para seguir em frente e recuperar parte de sua sanidade.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    },
                    failure: ()=>{
                        this._game.characterManager.characterSofiia.looseSanity(15);
                        this._game.characterManager.makeSomeoneInTheGroupGetStatus("Sofiia", "Desespero");
                        this._game.log.addTempLog("A esperan\xe7a de Sofiia se despeda\xe7a, e ela \xe9 tomada por um profundo desespero.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
                    }
                }
            },
            normalResultPath: null
        }, {
            buttonText: "Desespero",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{
                this._game.characterManager.characterSofiia.looseSanity(5);
                this._game.log.addTempLog("Sofiia sucumbe ao desespero, vendo sua sanidade lentamente se esvair.", (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
            }
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Psychological, this._game.characterManager.characterSofiia));
        return events;
    }
}


class $bb1a6a7c453618b7$export$aded6179390a47eb {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._events = [];
        this._triggeredEvents = new Set();
    }
    start() {
        this._events.push(...(0, $cf06d41d2f58e0f1$export$6570b7397a911979).createDmytroEvents());
        this._events.push(...(0, $cc0da5454376274a$export$2be9c7801c485772).createMykolaEvents());
        this._events.push(...(0, $c4173844005aa122$export$b1388e5e6738eebe).createOlenaEvents());
        this._events.push(...(0, $93631e155b1431be$export$442f8eaeaf400087).createSofiiaEvents());
    }
    get events() {
        return this._events;
    }
    getPlaceEvent() {
        const availableEvents = this._events.filter((event)=>!this._triggeredEvents.has(event.title));
        if (availableEvents.length === 0) return null; // Retorna null se todos os eventos já aconteceram
        const selectedEvent = availableEvents[Math.floor(Math.random() * availableEvents.length)];
        this._triggeredEvents.add(selectedEvent.title);
        return selectedEvent;
    }
    getMileStoneEvent() {
        return new (0, $bc031f55e87bf7fc$export$d61e24a684f9e51)("Marcos Alcan\xe7ado!", `${this._game.distanceToTheBorder} milhas para a fronteira`, "milestone", {
            buttonText: "Voltar para a viagem",
            skillCheck: false,
            skillCheckFields: null,
            normalResultPath: ()=>{}
        }, (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Exploration, null, null);
    }
}




class $850a1102bbecb448$export$bc2350a2190206a5 {
    constructor(canvasId){
        this.percentageTable = {
            "1": 16.67,
            "2": 16.67,
            "3": 16.67,
            "4": 16.67,
            "5": 16.67,
            "6": 16.67
        };
        this.canvas = document.getElementById(canvasId);
        this.ctx = this.canvas.getContext("2d");
        this.diceSize = 150;
        this.cornerRadius = 20;
        this.dotRadius = 10;
        // Definindo as posições das bolinhas para as faces do dado
        this.positions = [
            [],
            [
                [
                    0,
                    0
                ]
            ],
            [
                [
                    -1,
                    -1
                ],
                [
                    1,
                    1
                ]
            ],
            [
                [
                    -1,
                    -1
                ],
                [
                    0,
                    0
                ],
                [
                    1,
                    1
                ]
            ],
            [
                [
                    -1,
                    -1
                ],
                [
                    -1,
                    1
                ],
                [
                    1,
                    -1
                ],
                [
                    1,
                    1
                ]
            ],
            [
                [
                    -1,
                    -1
                ],
                [
                    -1,
                    1
                ],
                [
                    0,
                    0
                ],
                [
                    1,
                    -1
                ],
                [
                    1,
                    1
                ]
            ],
            [
                [
                    -1,
                    -1
                ],
                [
                    -1,
                    0
                ],
                [
                    -1,
                    1
                ],
                [
                    1,
                    -1
                ],
                [
                    1,
                    0
                ],
                [
                    1,
                    1
                ]
            ] // 6
        ];
    }
    start() {}
    getDifficult(difficulty) {
        switch(difficulty){
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).TRIVIAL:
                return {
                    value: 1,
                    text: "Trivial",
                    class: "green-color-border"
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).EASY:
                return {
                    value: 2,
                    text: "Easy",
                    class: "green-color-border"
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).MEDIUM:
                return {
                    value: 3,
                    text: "Medium",
                    class: "green-color-border"
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).CHALLENGING:
                return {
                    value: 4,
                    text: "Challenging",
                    class: "yellow-color-border"
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).VERY_HARD:
                return {
                    value: 5,
                    text: "Very Hard",
                    class: "red-color-border"
                };
            case (0, $dc2bb2a9cc4e234e$export$6fb808e876d73c01).IMPOSSIBILE:
                return {
                    value: 6,
                    text: "Impossibile",
                    class: "red-color-border"
                };
        }
    }
    calculateProbabilityFrom(value) {
        if (value > 12) value = 12;
        if (value <= 1) value = 2;
        return this.percentageTable[value] + "%";
    }
    getRandomNumber(start, end) {
        let min = Math.ceil(start);
        let max = Math.floor(end);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    drawRoundedRect(x, y, width, height, radius) {
        this.ctx.beginPath();
        this.ctx.moveTo(x + radius, y);
        this.ctx.arcTo(x + width, y, x + width, y + height, radius);
        this.ctx.arcTo(x + width, y + height, x, y + height, radius);
        this.ctx.arcTo(x, y + height, x, y, radius);
        this.ctx.arcTo(x, y, x + width, y, radius);
        this.ctx.closePath();
        this.ctx.fillStyle = "black"; // Preenchendo o dado com preto
        this.ctx.fill();
        this.ctx.lineWidth = 5;
        this.ctx.strokeStyle = "white"; // Contorno branco para o dado
        this.ctx.stroke();
    }
    drawDots(diceValue) {
        const centerX = this.canvas.width / 2;
        const centerY = this.canvas.height / 2;
        const spacing = this.diceSize / 4;
        this.ctx.fillStyle = "white"; // Bolinhas brancas
        this.positions[diceValue].forEach(([xPos, yPos])=>{
            const x = centerX + xPos * spacing;
            const y = centerY + yPos * spacing;
            this.ctx.beginPath();
            this.ctx.arc(x, y, this.dotRadius, 0, Math.PI * 2);
            this.ctx.fill();
        });
    }
    drawDice(diceValue) {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        // Desenha o retângulo arredondado (o dado)
        const x = (this.canvas.width - this.diceSize) / 2;
        const y = (this.canvas.height - this.diceSize) / 2;
        this.drawRoundedRect(x, y, this.diceSize, this.diceSize, this.cornerRadius);
        // Desenha as bolinhas de acordo com o valor do dado
        this.drawDots(diceValue);
    }
    getRandomDiceValue() {
        return Math.floor(Math.random() * 6) + 1;
    }
    stopDice(value) {
        clearInterval(this._diceTimer);
        this.drawDice(value);
    }
    animateDice() {
        this._diceTimer = setInterval(()=>{
            const diceValue = this.getRandomDiceValue();
            this.drawDice(diceValue);
        }, 50);
    }
}


var $7af210b2301dcb2b$exports = {};
$7af210b2301dcb2b$exports = new URL("ferris-wheel.1f801a79.jpg", import.meta.url).toString();


var $745ee9b08ea68788$exports = {};
$745ee9b08ea68788$exports = new URL("geyser.32da7bc5.jpg", import.meta.url).toString();


var $9310dbb3c6a26d49$exports = {};
$9310dbb3c6a26d49$exports = new URL("theme-park.82d60ef5.jpg", import.meta.url).toString();


var $5be9d9bb9dda9e1c$exports = {};
$5be9d9bb9dda9e1c$exports = new URL("barn-abandoned-farm-homestead.a8755b47.jpg", import.meta.url).toString();


class $cbb58ac183868e7d$export$cc74486daaaef499 {
    constructor(){
        this._titleElement = document.getElementById("event-page-title");
        this._descriptionElement = document.getElementById("event-page-description");
        this._photographyBorder = document.querySelector(".photography-border");
        this._eventPageChoicesBtnListElement = document.getElementById("event-page-choices-btn-list");
        this._imageElement = document.getElementById("event-page-image");
        this._images = new Map([
            [
                "ferrisWheel",
                new URL($7af210b2301dcb2b$exports).toString()
            ],
            [
                "geysir",
                new URL($745ee9b08ea68788$exports).toString()
            ],
            [
                "themePark",
                new URL($9310dbb3c6a26d49$exports).toString()
            ],
            [
                "barn",
                new URL($5be9d9bb9dda9e1c$exports).toString()
            ]
        ]);
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
    }
    start() {
        console.log("event page");
        this._eventPageChoicesBtnListElement.innerHTML = "";
        const eventSeeds = new (0, $bb1a6a7c453618b7$export$aded6179390a47eb)();
        eventSeeds.start();
        let events = eventSeeds.events;
        let randomEventType = this._game.getRandomArbitrary(1);
        if (this.checkForMileStone()) this._currentEvent = eventSeeds.getMileStoneEvent();
        else if (randomEventType == 0) this._currentEvent = eventSeeds.getPlaceEvent();
        this.showEvent();
    }
    showChoices() {
        this._eventPageChoicesBtnListElement.innerHTML = "";
        let diceManager = new (0, $850a1102bbecb448$export$bc2350a2190206a5)("dice-canvas");
        this.showChoice(this.currentEvent.firstChoice, diceManager);
        this.showChoice(this.currentEvent.secondChoice, diceManager);
    }
    showChoice(choice, diceManager) {
        const button = document.createElement("button");
        if (choice.skillCheck && choice.skillCheckFields) {
            choice.skillCheckFields.difficult = diceManager.getDifficult(choice.skillCheckFields.difficulty);
            let buttonText = choice.buttonText + " [" + choice.skillCheckFields.difficult.text + ": " + choice.skillCheckFields.difficult.value + " - " + diceManager.calculateProbabilityFrom(choice.skillCheckFields.difficult.value - 3) + "]";
            button.appendChild(document.createTextNode(buttonText));
            button.classList.add(choice.skillCheckFields.difficult.class);
        } else button.appendChild(document.createTextNode(choice.buttonText));
        button.addEventListener("click", ()=>this.selectChoice(choice));
        this._eventPageChoicesBtnListElement.appendChild(button);
    }
    selectChoice(choice) {
        this._game.audioManager.playButtonSound();
        this.currentChoice = choice;
        if (this.currentChoice.skillCheck) {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).SKILLCHECK);
            return;
        }
        if (this.currentEvent.type == (0, $bc031f55e87bf7fc$export$3d7865934588d77e).Place && choice.buttonText == "Investigate") {
            this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).ITEM_PICKER);
            return;
        }
        this.currentChoice.normalResultPath();
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
    get currentEvent() {
        return this._currentEvent;
    }
    checkForMileStone() {
        return this._game.distanceToTheBorder == 250 || this._game.distanceToTheBorder == 200 || this._game.distanceToTheBorder == 150 || this._game.distanceToTheBorder == 100 || this._game.distanceToTheBorder == 50;
    }
    showWaitingMessage() {
        this._titleElement.style.display = "none";
        this._photographyBorder.style.display = "none";
        this._descriptionElement.innerHTML = "Something happened!";
        this._imageElement.style.display = "none";
        setTimeout(()=>this.showEvent(), 1000);
    }
    getImagePath(imageName) {
        const imagePath = this._images.get(imageName);
        if (!imagePath) {
            console.error(`Image ${imageName} not found.`);
            return "";
        }
        return imagePath;
    }
    showEvent() {
        console.log("show event");
        this._titleElement.style.display = "block";
        this._photographyBorder.style.display = "block";
        this._titleElement.innerHTML = this._currentEvent.title;
        this._descriptionElement.innerHTML = this._currentEvent.description;
        if (this._currentEvent.image != "") {
            this._imageElement.src = "img\\places\\" + this._currentEvent.image + ".jpg";
            this._imageElement.src = this.getImagePath(this._currentEvent.image);
        }
        this._imageElement.style.display = "block";
        this.showChoices();
    }
}



class $fc8f23560e9fa5ff$export$e6f377c5bf36ff9f {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._gameOverMessage = document.querySelector("#game-over-message");
        this._tryAgainBtn = document.querySelector("#try-again-btn");
    }
    start() {
        this._tryAgainBtn.addEventListener("click", ()=>{
            this.onClickTryAgainBtn();
        });
        this.setGameOverMessage("You died with " + this._game.distanceToTheBorder + " miles to the border");
    }
    onClickTryAgainBtn() {
        this._game.audioManager.playButtonSound();
        location.reload();
    }
    setGameOverMessage(message) {
        this._gameOverMessage.innerHTML = message;
    }
}




class $dfe474540f60039a$export$63ed3fcf5e5b0cca {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._ripPageImageElement = document.querySelector("#rip-page-image");
        this._ripPageNameElement = document.querySelector("#rip-page-name");
        this._ripPageDatesElement = document.querySelector("#rip-page-dates");
        this._ripPageQuoteElement = document.querySelector("#rip-page-quote");
        this._ripPageStatusElement = document.querySelector("#rip-page-status");
        this._travelBtn = document.querySelector("#rip-page-back-btn");
        this._travelBtn.addEventListener("click", ()=>{
            this.onClickTravel();
        });
    }
    start() {
        const character = this._game.characterManager.getFirstCharacterDeadAndNotBuried();
        this.showCharater(character);
        character.buried = true;
    }
    showCharater(character) {
        this._ripPageImageElement.src = character.imageURL;
        this._ripPageNameElement.innerHTML = character.name + " Miller";
        this._ripPageDatesElement.innerHTML = "\u2B50 02/02/1996 - 20/03/2020 \u271D\uFE0F";
        this._ripPageQuoteElement.innerHTML = "I pray you find peace and rest wherever you are";
        this._ripPageStatusElement.innerHTML = '<span style="font-weight: bold;">Status:</span> Starved to death';
    }
    onClickTravel() {
        this._game.audioManager.playButtonSound();
        const character = this._game.characterManager.getFirstCharacterDeadAndNotBuried();
        if (character != null) {
            this.showCharater(character);
            character.buried = true;
        } else this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
}





class $514d467852c05e06$export$36eb8cca929288cd {
    constructor(){
        this._items = [];
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._itemListElement = document.querySelector("#bag-item-list");
        this._selectedItemElement = document.getElementById("bag-selected-item");
        this._selectedItemDescriptionElement = document.getElementById("bag-selected-item-description");
        this._bagCloseBtn = document.querySelector("#bag-close-btn");
        this._bagThrowAwayBtn = document.getElementById("bag-throw-away-btn");
        this._bagCloseBtn.addEventListener("click", ()=>{
            this.onClickBagClose();
        });
        this._bagThrowAwayBtn.addEventListener("click", ()=>{
            this.onClickThrowAway();
        });
    }
    start() {
        this.hideSelectedItem();
        this.showItems();
        this._bagThrowAwayBtn.style.display = "none";
    }
    onClickBagClose() {
        this._game.audioManager.playButtonSound();
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
    onClickThrowAway() {
        this._game.audioManager.playButtonSound();
        this.removeOrDecreaseItem();
        this._itemListElement.innerHTML = "";
        this._selectedItemElement.style.display = "none";
        this._selectedItemDescriptionElement.style.display = "none";
        this.showItems();
        this._bagThrowAwayBtn.style.display = "none";
    }
    hideSelectedItem() {
        this._selectedItemElement.innerHTML = "";
        this._selectedItemElement.style.display = "none";
        this._selectedItemDescriptionElement.style.display = "none";
    }
    showSelectedItem() {
        this._selectedItemElement.style.display = "block";
        this._selectedItemDescriptionElement.style.display = "block";
    }
    showItems() {
        this._itemListElement.innerHTML = "";
        if (this._items.length == 0) {
            this._itemListElement.innerHTML = "Empty";
            return;
        }
        for (let item of this._items){
            const li = document.createElement("li");
            const button = document.createElement("button");
            button.appendChild(document.createTextNode(item.name + " (" + item.status.name + ") " + item.showAmount()));
            button.addEventListener("click", ()=>this.selectItem(item));
            li.appendChild(button);
            this._itemListElement.appendChild(li);
        }
    }
    putItem(itemToPut) {
        let existingItemIndex = this._items.findIndex((item)=>item.name == itemToPut.name);
        if (existingItemIndex >= 0) this._items[existingItemIndex].increaseAmount();
        else this._items.push(itemToPut);
    }
    showCharacters() {
        for (const character of this._game.characters){
            const li = document.createElement("li");
            const button = document.createElement("button");
            button.classList.add("bag-item");
            let buttonText = character.name;
            var paragraph = document.createElement("p");
            if (character.isDead) {
                button.disabled = true;
                paragraph.classList.add("line");
                paragraph.style.color = "#2c3e50";
            } else {
                buttonText += character.getSanity();
                buttonText += character.showAfflictions();
            }
            paragraph.appendChild(document.createTextNode(buttonText));
            button.appendChild(paragraph);
            button.addEventListener("click", ()=>this.useItem(character));
            li.appendChild(button);
            this._itemListElement.appendChild(li);
        }
    }
    selectItem(selectedItem) {
        this._selectedItem = selectedItem;
        this._itemListElement.innerHTML = "";
        this._selectedItemElement.innerHTML = `Give ${this._selectedItem.name} ${this._selectedItem.status.name} to:`;
        if (this._selectedItem.type == ItemType.FirstAid) this._selectedItemDescriptionElement.innerHTML = "Can help with " + this._selectedItem.status.name;
        this.showSelectedItem();
        this.showCharacters();
        this._bagThrowAwayBtn.style.display = "block";
    }
    useItem(character) {
        this.removeOrDecreaseItem();
        this.hideSelectedItem();
        this.showItems();
        character.removeStatus();
        this._bagThrowAwayBtn.style.display = "none";
    }
    removeOrDecreaseItem() {
        if (this._selectedItem.amount > 1) this._selectedItem.decreaseAmount();
        else this.removeItem(this._selectedItem.name);
    }
    removeItem(itemName) {
        this._items = this._items.filter((item)=>item.name !== itemName);
    }
    checksIfAnItemExists(itemName) {
        let existingItemIndex = this._items.findIndex((item)=>item.name == itemName);
        return existingItemIndex != -1 ? true : false;
    }
    isEmpty() {
        return this._items.length <= 0;
    }
    showQuantityOfItems() {
        let itemCount = 0;
        for(let i = 0; i < this._items.length; i++)itemCount += this._items[i].amount == 0 ? 1 : this._items[i].amount;
        return itemCount;
    }
}




class $4b7b87bfcd759858$export$4d5c8163a511d38a {
    constructor(){
        this.currentState = (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG;
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
    }
    start() {}
    setState() {
        this._game.hideAllPages();
        switch(this.currentState){
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).EVENT:
                this._game.showPage(this._game.eventPage);
                this._game.eventManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).SKILLCHECK:
                this._game.showPage(this._game.skillCheckPage);
                this._game.skillCheckManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG:
                this._game.showPage(this._game.logPage);
                this._game.logManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER:
                this._game.showPage(this._game.gameOverPage);
                this._game.gameOverManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).RIP:
                this._game.showPage(this._game.ripPage);
                this._game.ripManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).BAG:
                this._game.showPage(this._game.bagPage);
                this._game.bagManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).ITEM_PICKER:
                this._game.showPage(this._game.itemPickerPage);
                this._game.itemPickerManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).SKILL_UP:
                this._game.showPage(this._game.skillUpPage);
                this._game.skillUpManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).DIALOG:
                this._game.showPage(this._game.dialogPage);
                this._game.dialogManager.start();
                break;
            case (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).MAP:
                this._game.showPage(this._game.mapPage);
                this._game.mapManager.start();
        }
    }
    goToState(state) {
        if (this.currentState == (0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER) return;
        this.currentState = state;
        this.setState();
    }
}







class $fa7535ab82d62b12$export$cb68cc2163cd3f1 {
    constructor(name, kinship, sanity = 100, dateOfBirth, isDead){
        this._sanity = 100;
        this._isDead = false;
        this._buried = false;
        this._sick = false;
        this._name = name;
        this._kinship = kinship;
        this._sanity = sanity;
        this._dateOfBirth = dateOfBirth;
        this._isDead = isDead;
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
    }
    get name() {
        return this._name;
    }
    get isDead() {
        return this._isDead;
    }
    get sanity() {
        return this._sanity;
    }
    get kinship() {
        return this._game.loc.l(this._kinship);
    }
    get buried() {
        return this._buried;
    }
    set buried(buried) {
        this._buried = buried;
    }
    get imageURL() {
        return this._imageURL;
    }
    set imageURL(imageURL) {
        this._imageURL = imageURL;
    }
    walkOneHour() {
        if (this._status != null) this.looseSanity(this._status?.healthPerHour ?? 0);
    }
    checksIfAnStatusExists(statusName) {
        return this._status?.name == statusName;
    }
    setStatus(status) {
        this._game.logManager.addTempLog(this._name + " pegou: " + status.name, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        this._status = status;
    }
    removeStatus() {
        this._status = null;
    }
    showAfflictions() {
        return this._status?.name ?? "";
    }
    getSanity() {
        return "Sanity: " + this._sanity + "%";
    }
    getSickness() {
        return this._sick ? "Sick" : "Not sick";
    }
    getDateOfBirth() {
        return this._dateOfBirth;
    }
    sicken() {
        this._sick = true;
    }
    looseSanity(sanityToLoose) {
        if (sanityToLoose < 0 || sanityToLoose > 100) throw new Error("Invalid value for healthToLoose");
        if (this._sanity > 0) {
            this._sanity -= sanityToLoose;
            if (this._sanity <= 0) {
                this._sanity = 0;
                this._isDead = true;
                if (this._kinship == "you") this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).GAME_OVER);
            }
        }
    }
    increaseSanity(sanityToIncrease) {
        this._sanity += sanityToIncrease;
        if (this._sanity > 100) this._sanity = 100;
    }
}


class $0a8e38866719ea09$export$96e9906d6d93a972 {
    constructor(name, healthPerHour, effect){
        this.name = name;
        this.healthPerHour = healthPerHour;
        this.effect = effect;
    }
}
var $0a8e38866719ea09$export$1e6e956a5bf5b9ce;
(function(StatusEffect) {
    StatusEffect["POSITIVE"] = "Positive";
    StatusEffect["NEGATIVE"] = "Negative";
})($0a8e38866719ea09$export$1e6e956a5bf5b9ce || ($0a8e38866719ea09$export$1e6e956a5bf5b9ce = {}));


class $831adfd47f352819$export$1d855623f2a478b9 {
    static{
        this.items = [
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Ansiedade", 10, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Paranoia", 20, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Desespero", 30, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Culpa", 15, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Medo", 15, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Alucina\xe7\xf5es", 25, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Isolamento", 20, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Depress\xe3o", 10, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("Trauma", 35, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE),
            new (0, $0a8e38866719ea09$export$96e9906d6d93a972)("P\xe2nico", 25, (0, $0a8e38866719ea09$export$1e6e956a5bf5b9ce).NEGATIVE)
        ];
    }
    static getStatusByName(name) {
        return $831adfd47f352819$export$1d855623f2a478b9.items.find((affliction)=>affliction.name == name);
    }
}


class $ea43a44514016353$export$5f400b495260ae4b {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this.createAllCharacters();
        this.savePreviousCharacters();
        this.characters = [
            this.characterDmytro,
            this.characterOlena,
            this.characterMykola,
            this.characterSofiia
        ];
        this.previousCharacters = [
            this.previousCharacterDmytro,
            this.previousCharacterOlena,
            this.previousCharacterMykola,
            this.previousCharacterSofiia
        ];
    }
    start() {
        for(let i = 0; i < this.characters.length; i++){
            const imgElement = document.getElementById("rip-page-image-" + (i + 1));
            if (imgElement) this.characters[i].imageURL = imgElement.src;
        }
    }
    getCharactersDead() {
        return this.characters.filter((character)=>character.isDead);
    }
    createAllCharacters() {
        this.characterDmytro = new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)("Dmytro", "you", 100, "1985", false);
        this.characterOlena = new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)("Olena", "wife", 100, "1988", false);
        this.characterMykola = new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)("Mykola", "son", 100, "2003", false);
        this.characterSofiia = new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)("Sofiia", "daughter", 100, "2005", false);
    }
    savePreviousCharacters() {
        this.previousCharacterDmytro = this.cloneCharacter(this.characterDmytro);
        this.previousCharacterOlena = this.cloneCharacter(this.characterOlena);
        this.previousCharacterMykola = this.cloneCharacter(this.characterMykola);
        this.previousCharacterSofiia = this.cloneCharacter(this.characterSofiia);
    }
    cloneCharacter(character) {
        return new (0, $fa7535ab82d62b12$export$cb68cc2163cd3f1)(character.name, character.kinship, character.sanity, character.getDateOfBirth(), character.isDead);
    }
    getNumberOfCharactersAlive() {
        return this.characters.filter((character)=>!character.isDead).length;
    }
    getCharactersAlive() {
        return this.characters.filter((character)=>!character.isDead);
    }
    getFirstCharacterDeadAndNotBuried() {
        return this.characters.find((character)=>character.isDead && !character.buried);
    }
    isInDanger() {
        return this.getCharactersAlive().some((character)=>character.sanity <= 25);
    }
    picksACharacterAtRandom() {
        const characters = this.getCharactersAlive();
        const randomNumber = Math.floor(this._game.getRandomArbitrary(characters.length));
        return characters[randomNumber];
    }
    makeSomeoneInTheGroupGetStatus(characterName, status) {
        const character = this.getCharacterByName(characterName);
        character.setStatus((0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName(status));
        return character;
    }
    getCharacterByName(characterName) {
        return this.characters.find((character)=>character.name === characterName);
    }
    decreasesTheHealthOfSomeoneInTheGroup() {
        const character = this.picksACharacterAtRandom();
        character.looseSanity(30);
        return character;
    }
    statusOfTheCharactersChange() {
        const currentCharacters = this.characters;
        const previousCharacters = this.previousCharacters;
        for(let i = 0; i < currentCharacters.length; i++)if (!previousCharacters[i].isDead && previousCharacters[i].sanity !== currentCharacters[i].sanity) {
            this.savePreviousCharacters();
            return true;
        }
        return false;
    }
}



var $47bc382d10598f77$exports = {};
$47bc382d10598f77$exports = JSON.parse('{"walk-one-hour":"Walk","your-family":"Those You Love","miles-to-the-border":"km","you":"you","wife":"wife","son":"son","daughter":"daughter","day":"day","daylight":"daylight","strength":"Strength","speak":"Speak","stealth":"Stealth","exploration":"Exploration","bag-is-empty":"Bag is empty"}');


var $b958af03c4b8e2fb$exports = {};
$b958af03c4b8e2fb$exports = JSON.parse('{"walk-one-hour":"Andar","your-family":"Aqueles que Voc\xea Ama","miles-to-the-border":"km","you":"voc\xea","wife":"esposa","son":"filho","daughter":"filha","day":"dia","daylight":"luz do dia","strength":"For\xe7a","speak":"Labia","stealth":"Furtividade","exploration":"Explora\xe7\xe3o","bag-is-empty":"A bolsa esta vazia"}');


var $ae8a3c12e902894e$export$ce4fe1c9e6520c1a;
(function(Language) {
    Language[Language["EnUs"] = 0] = "EnUs";
    Language[Language["PtBr"] = 1] = "PtBr";
})($ae8a3c12e902894e$export$ce4fe1c9e6520c1a || ($ae8a3c12e902894e$export$ce4fe1c9e6520c1a = {}));
class $ae8a3c12e902894e$export$30e2160809baa85b {
    constructor(language){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._currentLanguage = language;
    }
    l(key) {
        switch(this._currentLanguage){
            case 0:
                return $47bc382d10598f77$exports[key];
            case 1:
                return $b958af03c4b8e2fb$exports[key];
            default:
                return "Localization Error";
        }
    }
}



class $2e2fe657008a9c1e$export$6fd0fa83e2652332 {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
    }
    start() {}
}



class $1b9b55c6f4e5d90c$export$c521bb0b406df9a3 {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
    }
    start() {}
}



class $ebc00ba050c95b45$export$c47b82c298155c1d {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
    }
    start() {}
}


class $887e7e81328f4c8b$export$9735c82c4bae3302 {
    constructor(currentHour, anteMediem){
        this._currentHour = currentHour;
        this._anteMeridiem = anteMediem;
    }
    get currentHour() {
        return this._currentHour;
    }
    get anteMeridiem() {
        return this._anteMeridiem;
    }
    nextHour() {
        if (this._currentHour == 11) this._anteMeridiem = !this._anteMeridiem;
        if (this._currentHour == 12) this._currentHour = 1;
        else this._currentHour++;
    }
    showTime() {
        return (this._currentHour <= 9 ? "0" : "") + this._currentHour.toString() + ":00 " + (this._anteMeridiem ? "a.m" : "p.m");
    }
}


class $7562dc76fff808dc$export$6d08773d2e66f8f2 {
    constructor(name, status){
        this._name = name;
        this._amount = 0;
        this._status = status;
    }
    get name() {
        return this._name;
    }
    get amount() {
        return this._amount;
    }
    get status() {
        return this._status;
    }
    set amount(amount) {
        this._amount = amount;
    }
    showAmount() {
        return this._amount > 1 ? " x " + this._amount : "";
    }
    decreaseAmount() {
        this._amount--;
    }
    increaseAmount() {
        this._amount++;
    }
}



var $a586de1731fab2a5$export$f3af6ebb74930929;
(function(ItemsNames) {
    ItemsNames[ItemsNames["FirstAid"] = 0] = "FirstAid";
    ItemsNames[ItemsNames["Food"] = 1] = "Food";
})($a586de1731fab2a5$export$f3af6ebb74930929 || ($a586de1731fab2a5$export$f3af6ebb74930929 = {}));
class $a586de1731fab2a5$export$188d8cb5ec09e5c7 {
    static{
        this.items = [
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Comprimidos de Diazepam", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Ansiedade")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Seringa de Morfina", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Paranoia")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Lata de Cafe\xedna Pura", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Desespero")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Di\xe1rio Rasgado", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Culpa")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Crucifixo de Bolso", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Medo")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Foto Desgastada", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Alucina\xe7\xf5es")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Carta de Um Ente Querido", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Isolamento")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Cartela de Antidepressivos", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Depress\xe3o")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Kit de Primeiros Socorros B\xe1sico", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("Trauma")),
            new (0, $7562dc76fff808dc$export$6d08773d2e66f8f2)("Comprimidos de Anfetamina", (0, $831adfd47f352819$export$1d855623f2a478b9).getStatusByName("P\xe2nico"))
        ];
    }
    static getItens(name, amount) {
        this.items[name].amount = amount;
        return this.items[name];
    }
    static getOneRandomItem() {
        return $a586de1731fab2a5$export$188d8cb5ec09e5c7.items[$a586de1731fab2a5$export$188d8cb5ec09e5c7.getRandomArbitrary(0, $a586de1731fab2a5$export$188d8cb5ec09e5c7.items.length)];
    }
    static getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }
}



class $1274f8cb9d11f882$export$8be8c2ff45d443a3 {
    constructor(){}
    roll() {
        let min = Math.ceil(1);
        let max = Math.floor(6);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}





var $9e93b9db2423d7df$export$d6c3ad4e8d47378f;
(function(SkillCheckResults) {
    SkillCheckResults[SkillCheckResults["Success"] = 0] = "Success";
    SkillCheckResults[SkillCheckResults["Failure"] = 1] = "Failure";
})($9e93b9db2423d7df$export$d6c3ad4e8d47378f || ($9e93b9db2423d7df$export$d6c3ad4e8d47378f = {}));
class $9e93b9db2423d7df$export$ee498bc1e428f957 {
    constructor(){
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._resultLabel = document.querySelector("#skill-check-result-label");
        this._travelBtn = document.querySelector("#skill-check-back-btn");
        this._skillCheckExpected = document.querySelector("#skill-check-expected");
        this._travelBtn.addEventListener("click", ()=>{
            this.onClickTravel();
        });
        this._diceManager = new (0, $850a1102bbecb448$export$bc2350a2190206a5)("dice-canvas");
    }
    start() {
        this._currentChoice = this._game.eventManager.currentChoice;
        let expectedValue = this._currentChoice.skillCheckFields.difficult.value;
        this._skillCheckExpected.innerHTML = "M\xednimo Necess\xe1rio: " + expectedValue.toString();
        this._diceManager.animateDice();
        this._travelBtn.disabled = true;
        this._resultLabel.style.visibility = "hidden";
        setTimeout(()=>{
            this.startDiceRoll();
        }, 100);
    }
    startDiceRoll() {
        let dice = new (0, $1274f8cb9d11f882$export$8be8c2ff45d443a3)();
        this._game.audioManager.playDiceSound();
        setTimeout(()=>{
            this.stopShakeDice(dice);
        }, 500);
    }
    onClickTravel() {
        this._game.audioManager.playButtonSound();
        if (this._game.skillCheckResult == 0) {
            this._currentChoice.skillCheckFields.resultPath.success();
            if (this._currentChoice.skillCheckFields.canGiveItems) {
                this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).ITEM_PICKER);
                return;
            }
        } else if (this._game.skillCheckResult == 1) this._currentChoice.skillCheckFields.resultPath.failure();
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
    stopShakeDice(dice) {
        clearInterval(this._diceTimer);
        this._resultLabel.style.visibility = "visible";
        let diceValue = dice.roll();
        this._diceManager.stopDice(diceValue);
        let expectedValue = this._currentChoice.skillCheckFields.difficult.value;
        this._skillCheckExpected.innerHTML = "M\xednimo Necess\xe1rio: " + expectedValue.toString();
        this._travelBtn.disabled = false;
        if (diceValue == 6) {
            this._game.audioManager.playSuccessSound();
            this.setCriticalSuccess();
            this._game.skillCheckResult = 0;
            return;
        }
        if (diceValue == 1) {
            this._game.audioManager.playFailSound();
            this.setCriticalFailure();
            this._game.skillCheckResult = 1;
            return;
        }
        if (diceValue >= expectedValue) {
            this._game.audioManager.playSuccessSound();
            this.setSuccess();
            this._game.skillCheckResult = 0;
            return;
        }
        if (diceValue < expectedValue) {
            this._game.audioManager.playFailSound();
            this.setFailure();
            this._game.skillCheckResult = 1;
            return;
        }
    }
    setCriticalSuccess() {
        this._resultLabel.innerHTML = " CRITICIAL SUCCESS ";
        this._resultLabel.style.fontSize = "1.3em";
        this._resultLabel.classList.remove("red-color");
        this._resultLabel.classList.add("green-color");
    }
    setSuccess() {
        this._resultLabel.innerHTML = " SUCCESS ";
        this._resultLabel.style.fontSize = "2.5em";
        this._resultLabel.classList.remove("red-color");
        this._resultLabel.classList.add("green-color");
    }
    setCriticalFailure() {
        this._resultLabel.innerHTML = " CRITICIAL FAILURE ";
        this._resultLabel.style.fontSize = "1.3em";
        this._resultLabel.classList.add("red-color");
        this._resultLabel.classList.remove("green-color");
    }
    setFailure() {
        this._resultLabel.innerHTML = " FAILURE ";
        this._resultLabel.style.fontSize = "2.5em";
        this._resultLabel.classList.add("red-color");
        this._resultLabel.classList.remove("green-color");
    }
}






class $4ac31c89200f3453$export$3dc9b393db657566 {
    constructor(){
        this._itemsToPick = [];
        this._myItems = [];
        this._myItemsMax = 2;
        this.itemsFound = 4;
        this._game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
        this._continueBtn = document.querySelector("#item-picker-page-continue-btn");
        this._continueBtn.addEventListener("click", ()=>{
            this.onContinueBtn();
        });
        this._itemsToPickListElement = document.querySelector("#item-picker-page-items-to-pick");
        this._itemsFoundTitle = document.querySelector("#items-found-title");
        this._pageMessageElement = document.querySelector("#item-picker-page-message");
        this._myItemsListElement = document.querySelector("#item-picker-page-item-my-items");
        this._yourItemsTitle = document.querySelector("#your-items-title");
        this._takeAllBtn = document.querySelector("#item-picker-page-take-all-btn");
    }
    start() {
        this.showPageMessage();
        this._itemsToPick = [];
        this._myItems = [];
        this.character = this._game.characterManager.picksACharacterAtRandom();
        for(let i = 0; i < this.itemsFound; i++){
            let itemFounded = (0, $a586de1731fab2a5$export$188d8cb5ec09e5c7).getOneRandomItem();
            this.addItemToPick(itemFounded);
        }
        this.showItems();
    }
    showPageMessage() {
        this._itemsFoundTitle.style.display = "none";
        this._continueBtn.style.display = "none";
        this._itemsToPickListElement.style.display = "none";
        this._myItemsListElement.style.display = "none";
        this._yourItemsTitle.style.display = "none";
        this._takeAllBtn.style.display = "none";
        this._pageMessageElement.style.display = "block";
        setTimeout(()=>this.showPageElements(), 1500);
    }
    showPageElements() {
        this._itemsFoundTitle.style.display = "block";
        this._continueBtn.style.display = "block";
        this._itemsToPickListElement.style.display = "block";
        this._myItemsListElement.style.display = "block";
        this._yourItemsTitle.style.display = "block";
        this._takeAllBtn.style.display = "block";
        this._pageMessageElement.style.display = "none";
    }
    showItems() {
        if (this._itemsToPick.length <= this._myItemsMax - this._myItems.length) this._takeAllBtn.disabled = false;
        else this._takeAllBtn.disabled = true;
        this.showItemsToPick();
        this.showMyItems();
    }
    showItemsToPick() {
        this._itemsToPickListElement.innerHTML = "";
        for (let item of this._itemsToPick){
            const li = document.createElement("li");
            const button = document.createElement("button");
            button.appendChild(document.createTextNode(item.name + " (" + item.status.name + ") " + item.showAmount()));
            button.addEventListener("click", ()=>this.selectItemToPick(item));
            if (this._myItems.length >= this._myItemsMax) button.disabled = true;
            li.appendChild(button);
            this._itemsToPickListElement.appendChild(li);
        }
    }
    showMyItems() {
        this._yourItemsTitle.innerHTML = "Your items - (" + this._myItems.length + "/" + this._myItemsMax + ")";
        this._myItemsListElement.innerHTML = "";
        for (let item of this._myItems){
            const li = document.createElement("li");
            const button = document.createElement("button");
            button.appendChild(document.createTextNode(item.name + " (" + item.status.name + ") " + item.showAmount()));
            button.addEventListener("click", ()=>this.selectItemMyItem(item));
            li.appendChild(button);
            this._myItemsListElement.appendChild(li);
        }
    }
    selectItemToPick(selectedItem) {
        this._game.audioManager.playTakeItemSound();
        this.removeItemToPick(selectedItem.name);
        this.addMyItem(selectedItem);
        this.showItems();
    }
    selectItemMyItem(selectedItem) {
        this._game.audioManager.playThrowSound();
        this.removeMyItem(selectedItem.name);
        this.addItemToPick(selectedItem);
        this.showItems();
    }
    removeItemToPick(itemName) {
        this._itemsToPick = this._itemsToPick.filter((item)=>item.name !== itemName);
    }
    removeMyItem(itemName) {
        this._myItems = this._myItems.filter((item)=>item.name !== itemName);
    }
    addItemToPick(itemToPut) {
        let existingItemIndex = this._itemsToPick.findIndex((item)=>item.name == itemToPut.name);
        if (existingItemIndex >= 0) this._itemsToPick[existingItemIndex].increaseAmount();
        else this._itemsToPick.push(itemToPut);
    }
    addMyItem(itemToPut) {
        let existingItemIndex = this._myItems.findIndex((item)=>item.name == itemToPut.name);
        if (existingItemIndex >= 0) this._myItems[existingItemIndex].increaseAmount();
        else this._myItems.push(itemToPut);
    }
    onContinueBtn() {
        this._game.audioManager.playButtonSound();
        for(let i = 0; i < this._myItems.length; i++){
            this._game.bagManager.putItem(this._myItems[i]);
            this._game.log.addTempLog(this.character.name + " picked up " + this._myItems[i].name, (0, $9c7a2a4f88c432f6$export$a0472aa3a356446c).Result);
        }
        this._game.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
}


var $3429a38461c3eb6e$exports = {};
$3429a38461c3eb6e$exports = new URL("button1.3460f251.wav", import.meta.url).toString();


var $f67c9d5f1f08f118$exports = {};
$f67c9d5f1f08f118$exports = new URL("dice.cf49713f.mp3", import.meta.url).toString();


var $3a01d8a456af83be$exports = {};
$3a01d8a456af83be$exports = new URL("ding.5236e861.wav", import.meta.url).toString();


var $87eae7badc7a0ac4$exports = {};
$87eae7badc7a0ac4$exports = new URL("fail.55d51340.mp3", import.meta.url).toString();


var $09a3907f7b235bd7$exports = {};
$09a3907f7b235bd7$exports = new URL("rain.1e27d28c.mp3", import.meta.url).toString();


var $c25ee73e1d1658b1$exports = {};
$c25ee73e1d1658b1$exports = new URL("success.29c69069.wav", import.meta.url).toString();


var $9ddea6ece2399cee$exports = {};
$9ddea6ece2399cee$exports = new URL("take-item.b2a482b5.wav", import.meta.url).toString();


var $0fd53c4c5ac8ba09$exports = {};
$0fd53c4c5ac8ba09$exports = new URL("throw.d5edeef4.wav", import.meta.url).toString();


var $2d9aa6fa5068c2a9$exports = {};
$2d9aa6fa5068c2a9$exports = new URL("walk.1187eb9d.mpeg", import.meta.url).toString();


var $1329860d5bb0b271$exports = {};
$1329860d5bb0b271$exports = new URL("write.fb0b7b16.wav", import.meta.url).toString();


class $147779db9aa8deb0$export$557a8016f4e0c1ba {
    constructor(){
        this.noSound = false;
        this.audioEffects = new Audio();
        this.audioBackground = new Audio();
        this.sounds = new Map([
            [
                "button",
                new URL($3429a38461c3eb6e$exports).toString()
            ],
            [
                "dice",
                new URL($f67c9d5f1f08f118$exports).toString()
            ],
            [
                "ding",
                new URL($3a01d8a456af83be$exports).toString()
            ],
            [
                "fail",
                new URL($87eae7badc7a0ac4$exports).toString()
            ],
            [
                "rain",
                new URL($09a3907f7b235bd7$exports).toString()
            ],
            [
                "success",
                new URL($c25ee73e1d1658b1$exports).toString()
            ],
            [
                "takeItem",
                new URL($9ddea6ece2399cee$exports).toString()
            ],
            [
                "throw",
                new URL($0fd53c4c5ac8ba09$exports).toString()
            ],
            [
                "walk",
                new URL($2d9aa6fa5068c2a9$exports).toString()
            ],
            [
                "write",
                new URL($1329860d5bb0b271$exports).toString()
            ]
        ]);
    }
    // Método para tocar efeitos sonoros
    playSound(soundName, loop = false) {
        const soundSource = this.sounds.get(soundName);
        if (!soundSource) {
            console.error(`Sound ${soundName} not found.`);
            return;
        }
        if (loop) ;
        else this.playAudioEffect(soundSource);
    }
    // Métodos públicos para tocar sons específicos
    playButtonSound() {
        this.playSound("button");
    }
    playDiceSound() {
        this.playSound("dice");
    }
    playDingSound() {
        this.playSound("ding");
    }
    playFailSound() {
        this.playSound("fail");
    }
    playRainSound() {
        this.playSound("rain", true);
    }
    playSuccessSound() {
        this.playSound("success");
    }
    playTakeItemSound() {
        this.playSound("takeItem");
    }
    playThrowSound() {
        this.playSound("throw");
    }
    playWalkSound() {
        this.playSound("walk", true);
    }
    playWriteSound() {
        this.playSound("write");
    }
    // Métodos privados para tocar os sons
    async playAudioEffect(soundSource) {
        if (this.noSound) return;
        try {
            this.audioEffects.src = soundSource;
            await this.audioEffects.play();
        } catch (error) {
            console.error("Error playing audio effect:", soundSource, error);
        }
    }
    async playAudioLoop(soundSource) {
        if (this.noSound) return;
        try {
            this.audioBackground.src = soundSource;
            this.audioBackground.volume = 0.2;
            this.audioBackground.loop = true;
            await this.audioBackground.play();
        } catch (error) {
            console.error("Error playing audio loop:", soundSource, error);
        }
    }
}


class $7b066675d1aa79fa$export$985739bfa5723e08 {
    constructor(){
        this._currentDay = 1;
        this._hours = 0;
        this._distanceToTheBorder = 300;
        this.logPage = document.getElementById("log-page");
        this.eventPage = document.getElementById("event-page");
        this.skillCheckPage = document.getElementById("skill-check-page");
        this.gameOverPage = document.getElementById("game-over-page");
        this.ripPage = document.getElementById("rip-page");
        this.bagPage = document.getElementById("bag-page");
        this.itemPickerPage = document.getElementById("item-picker-page");
        this.dialogPage = document.querySelector("#dialog-page");
        this.mapPage = document.querySelector("#map-page");
        this.skillUpPage = document.querySelector("#skill-up-page");
        this.playerGuid = this.generateGuid();
    }
    static getInstance() {
        if (!$7b066675d1aa79fa$export$985739bfa5723e08._instance) $7b066675d1aa79fa$export$985739bfa5723e08._instance = new $7b066675d1aa79fa$export$985739bfa5723e08();
        return $7b066675d1aa79fa$export$985739bfa5723e08._instance;
    }
    start() {
        this.loc = new (0, $ae8a3c12e902894e$export$30e2160809baa85b)((0, $ae8a3c12e902894e$export$ce4fe1c9e6520c1a).PtBr);
        let dice = new (0, $850a1102bbecb448$export$bc2350a2190206a5)("dice-canvas");
        dice.start();
        this.bagManager = new (0, $514d467852c05e06$export$36eb8cca929288cd)();
        //this.addItemsToBag();
        this.characterManager = new (0, $ea43a44514016353$export$5f400b495260ae4b)();
        this.characterManager.start();
        this.eventManager = new (0, $cbb58ac183868e7d$export$cc74486daaaef499)();
        this.gameOverManager = new (0, $fc8f23560e9fa5ff$export$e6f377c5bf36ff9f)();
        this.skillCheckManager = new (0, $9e93b9db2423d7df$export$ee498bc1e428f957)();
        this.ripManager = new (0, $dfe474540f60039a$export$63ed3fcf5e5b0cca)();
        this._clock = new (0, $887e7e81328f4c8b$export$9735c82c4bae3302)(8, true);
        this.logManager = new (0, $9c7a2a4f88c432f6$export$49b118289be48034)();
        this.stateManager = new (0, $4b7b87bfcd759858$export$4d5c8163a511d38a)();
        this.itemPickerManager = new (0, $4ac31c89200f3453$export$3dc9b393db657566)();
        this.dialogManager = new (0, $2e2fe657008a9c1e$export$6fd0fa83e2652332)();
        this.mapManager = new (0, $1b9b55c6f4e5d90c$export$c521bb0b406df9a3)();
        this.skillUpManager = new (0, $ebc00ba050c95b45$export$c47b82c298155c1d)();
        this.audioManager = new (0, $147779db9aa8deb0$export$557a8016f4e0c1ba)();
        this.stateManager.goToState((0, $25f141f40fab0fb1$export$df7cd2a2d7088cfa).LOG);
    }
    get events() {
        return this.eventManager;
    }
    get log() {
        return this.logManager;
    }
    get clock() {
        return this._clock;
    }
    get hours() {
        return this._hours;
    }
    set hours(hours) {
        this._hours = hours;
    }
    get currentDay() {
        return this._currentDay;
    }
    get distanceToTheBorder() {
        return this._distanceToTheBorder;
    }
    get characters() {
        return this.characterManager.characters;
    }
    decreaseTheDistanceToTheBorder(distanceToDecrease) {
        this._distanceToTheBorder -= distanceToDecrease;
    }
    addDaysToCurrentDay(daysToAdd) {
        this._currentDay += daysToAdd;
    }
    addItemsToBag() {
        for(let i = 0; i < 10; i++)this.bagManager.putItem((0, $a586de1731fab2a5$export$188d8cb5ec09e5c7).getOneRandomItem());
    }
    showPage(page) {
        page.style.display = "flex";
    }
    hidePage(page) {
        page.style.display = "none";
    }
    hideAllPages() {
        this.hidePage(this.logPage);
        this.hidePage(this.eventPage);
        this.hidePage(this.skillCheckPage);
        this.hidePage(this.gameOverPage);
        this.hidePage(this.bagPage);
        this.hidePage(this.ripPage);
        this.hidePage(this.itemPickerPage);
        this.hidePage(this.skillUpPage);
        this.hidePage(this.dialogPage);
        this.hidePage(this.mapPage);
    }
    isDayLight() {
        if (this._clock.anteMeridiem) {
            if (this._clock.currentHour > 6 && this._clock.currentHour < 12) return true;
            else return false;
        } else {
            if (this._clock.currentHour > 6 && this._clock.currentHour < 12) return false;
            else return true;
        }
    }
    passOneHour() {
        if (this._clock.currentHour == 12 && this._clock.anteMeridiem) this.addDaysToCurrentDay(1);
        this._clock.nextHour();
    }
    generateGuid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }
    getRandomArbitrary(max) {
        return Math.floor(Math.random() * max);
    }
}


const $b4e14b6b8da86996$var$game = (0, $7b066675d1aa79fa$export$985739bfa5723e08).getInstance();
$b4e14b6b8da86996$var$game.start();


//# sourceMappingURL=index.03b39c92.js.map
